<template>
  <div id="child1" style="min-height: 300px">
    <div class="header1">
      <div class="time">
        <div class="islook">
          <el-checkbox v-model="model.fBuyCount" style="margin-right:8px;" />
          只看购买过的
        </div>
      </div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="商品名称：">
          <el-input v-model="model.stockName" placeholder="输入商品名称进行搜索" @keydown.native.enter="upList" />
        </el-form-item>
        <el-form-item label="订货编码：">
          <el-input v-model="model.fShortCode" placeholder="请输入订货编码" @keydown.native.enter="upList" />
        </el-form-item>
        <el-form-item label="需方编码：">
          <el-input v-model="model.fDemandStcokCode" placeholder="请输入需方编码" @keydown.native.enter="upList" />
        </el-form-item>
        <el-form-item label="排列方式：">
          <el-select v-model="model.sortType" placeholder="请选择排序方式">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-button style="width: 69px; height: 36px" type="primary" @click="upList">查询</el-button>
    </div>
    <div class="body1">
      <template v-for="(item, index) in list">
        <div :key="index + 's'" class="combox" @click="toDetail(item)">
          <div class="imgbox">
            <template v-if="item.fCover">
              <img width="196px" height="196px" :src="item.fCover" alt>
            </template>
            <template v-else>
              <img
                style="object-fit: contain"
                width="172px"
                height="172px"
                src="@/assets/images/stockImg.jpg"
                alt
              >
            </template>
            <div v-if="!item.FOperationMode" class="self-support">自营</div>
          </div>
          <div class="contentbox">
            <div v-if="FPriceShow" class="price">
              <template v-if="item.IsDirectoryPool">
                <span style="font-size: 16px; font-weight: bold; color: #ec212d">
                  {{ _stockPrice(item.fStockPrice,item.FTPriceDecimal) }}
                  <span v-if="item.fMeasurement">
                    /{{ item.fMeasurement }}
                  </span>
                </span>
                <span style="font-size:12px;color:#666;text-decoration: line-through;margin-left: 8px;">
                  ￥{{  _stockPrice(item.fPrice,item.FTPriceDecimal)}}
                  <span v-if="item.fMeasurement">
                    /{{ item.fMeasurement }}
                  </span>
                </span>
                <span v-show="item.FBuyCount > 0" class="isshoped">购买过</span>
              </template>
              <div v-else class="isDirectoryPool">
                不在目录池
              </div>
            </div>
            <div v-else id="noShowPrice">
              <span>￥</span>价格不可见
              <svg-icon
                class="shopcar"
                style="cursor: pointer"
                icon-class="gouwuche"
                @click.stop="ShopUp(item)"
              />
            </div>
            <div class="title" :title="item.fStockName">
              {{ item.fStockName }}
            </div>
            <div class="bianma" :title="item.FShortCode">
              订货编码:
              <div>{{ item.FShortCode | filterCode }}</div>
              <i
                v-show="item.FShortCode"
                class="el-icon-document-copy"
                @click.stop.prevent="copyClick(item.FShortCode)"
              />
            </div>
            <div class="bianma" :title="item.FDemandStcokCode">
              需方编码:
              <div>{{ item.FDemandStcokCode | filterCode }}</div>
              <i
                v-show="item.FDemandStcokCode"
                class="el-icon-document-copy"
                @click.stop.prevent="copyClick(item.FDemandStcokCode)"
              />
            </div>

            <div
              style="
                font-size: 12px;
                margin-right: 9px;

                color: #666666;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
              "
            >
              <span style="line-height: 16px">
                发货日：<span v-if="item.fDeliveryInfo" class="deliverData">{{
                  item.fDeliveryInfo
                }}</span>
              </span>
              <span style="float: right">
                <svg-icon style="margin-right: 5px" icon-class="address" />{{
                  assderFilt(item.fLevelName)
                }}
              </span>
            </div>
            <div class="ability">
              <template v-if="item.IsDirectoryPool">
                <div style="display: flex;justify-content: space-between;">
                  <div class="ability-btn" @click.stop="collection(item)">
                    <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="item.fCollectioned ? 'collection2' : 'collection'" /></span>
                    <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="collection1" /></span>
                    <span :class="item.fCollectioned ? '' : 'writeText'">{{ item.fCollectioned ? '已收藏' : '收藏' }}</span>
                  </div>
                  <div class="ability-btn" @click.stop="addCart(item)">
                    <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="item.isAddCart ? 'cart' : 'cart2'" /></span>
                    <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="cart1" /></span>
                    <span :class="item.isAddCart ? '' : 'writeText'">{{ item.isAddCart ? '已加入购物车' : '加入购物车' }}</span>
                  </div>
                </div>
              </template>
              <el-popover
                v-else
                placement="top-start"
                trigger="hover"
                width="160"
              >
                <div slot="reference" style="width:100%;" class="ability-btn">
                  <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone1" /></span>
                  <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="newPhone2" /></span>
                  联系我们
                </div>
                <div>
                  <div>
                    <svg-icon style="margin-right: 5px;" icon-class="red-user" />
                    {{ $store.state.user | userName }}
                  </div>
                  <div>
                    <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone" /></span>
                    {{ $store.state.user | userPhone }}
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import quest from '../../api/user'
export default {
  filters: {
    filterCode(val) {
      if (val) return val.slice(0, 9)
    },
    userPhone(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return rightstr
      } else {
        return ''
      }
    },
    userName(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return leftstr
      } else {
        return ''
      }
    }
  },
  props: {
    list: {
      type: [Array, Object],
      default: function() {
        return []
      }
    },
    model: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      messgeForm: {
        begintime: '',
        endtime: ''
      },
      selectdown: [],
      selectClass: [],
      FPriceShow: 0,
      options: [{
        value: 0,
        label: '收藏时间'
      },
      {
        value: 1,
        label: '购买频次'
      }

      ]
    }
  },
  mounted() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    this.$emit('up-date', true)
  },
  methods: {
    _stockPrice(val,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      return price
    },
    addCart(item) {
      if (!localStorage.getItem('userInfo')) return this.$router.push({ path: '/login/login' })
      const jsonobj = {
        'shoppingCartList': [{
          'fstockName': item.fStockName,
          'fmallstoreStockId': item.fmallstoreStockId,
          'fQuanty': 1
        }]
      }
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      request({
        url: '/mall/stockmanage/mallstorestock/addShoppingCart',
        method: 'post',
        data: params
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$set(item, 'isAddCart', 1)
            this.$parent.$parent.$parent.$refs.rightNav.getComput()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    collection(item) {
      if (!localStorage.getItem('userInfo')) return this.$router.push({ path: '/login/login' })
      const operationType = item.fCollectioned ? 3 : 1
      const url = `/mall/stockmanage/mallstorestock/collectStock/${item.fmallstoreStockId}/0/${operationType}`
      request({
        url,
        method: 'get'
      })
        .then(res => {
          if (res.result) {
            item.fCollectioned = item.fCollectioned ? 0 : 1
            this.$emit('up-date', 'reset')
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    toDetail(item) {
      this.$router.push({
        path: '/store/details',
        query: {
          mallstorestockFId: item.fmallstoreStockId,
          shopid: item.fMallStoreId
        }
      })
    },
    // 复制字体
    copyClick(val = '') {
      if (!val) return
      const input = document.createElement('input')
      // 创建input对象
      // const testDiv = document.querySelector('.testDiv')
      // 获取需要复制文字的容器
      input.value = val
      // 设置复制内容
      document.body.appendChild(input)
      // 添加临时实例
      input.select()
      // 选择实例内容
      document.execCommand('Copy')
      // 执行复制
      document.body.removeChild(input)
      // 删除临时实例
      this.$message.success('复制成功！')
    },
    assderFilt(item) {
      const asderr = item.split('\\')

      let index = asderr.find((items) => {
        if (items) {
          return String(items).search('市') > -1
        } else {
          return false
        }
      })
      if (!index) {
        index = asderr[asderr.length - 1]
      }
      return index
    },
    picrFilter(item) {
      const arr = [
        item.fNoAPPrice,
        item.fOnMAPPrice,
        item.fTwMAPPrice,
        item.fThMAPPrice,
        item.fFoMAPPrice,
        item.fFiMAPPrice
      ]
      const showPrice = arr[Number(item.fOutDayLimit)]
      const showSpliPrice = showPrice.toString().split('.')
      const str = !isNaN(Number(showPrice))
        ? Number(showPrice).toFixed(3)
        : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    FixedTo(num) {
      const str = !isNaN(Number(num)) ? Number(num).toFixed(3) : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    upList(select) {
      if (select) {
        if (this.selectClass.indexOf(select) < 0) {
          this.selectClass = [select]
          this.model.fStockClassId = select.stdStockClassId
        } else {
          this.selectClass = []
          delete this.model.fStockClassId
        }
      }
      this.$emit('up-date', true)
    },
    // upListtop(select) {
    //   if (select) {
    //     if (this.selectdown.indexOf(select) < 0) {
    //       this.selectdown = [select]
    //       this.model.priceChangeType = select.id
    //     } else {
    //       this.selectdown = []
    //       delete this.model.priceChangeType
    //     }
    //   }
    //   this.$emit('up-date', true)
    // },
    ShopUp(shop) {
      const data = [{
        fstockName: shop.fStockName,
        fmallstoreStockId: shop.fmallstoreStockId,
        fQuanty: 1
      }]
      this.$emit('shop-up', data)
    }
  }
}
</script>

<style lang="scss">
    .demo-form-inline {
        width: 72%;

        .el-form-item {
            width: calc(25% - 24px);
            margin-bottom: 0;
            margin-right: 24px;

            .el-form-item__label {
                font-weight: normal;
                font-size: 14px !important;
                color: #666;
                padding:0 5px 0 0;
            }

            .el-form-item__content {
                width: calc(100% - 85px);
            }

            .el-input__inner {
                height: 36px;
                line-height: 36px;
            }

            .el-button {
                padding: 6px 15px;
            }
        }
    }

    .dropdown-icon-list,
    .dropdown-icon-list-top {
        ul {
            user-select: none;
            -webkit-user-select: none;
            display: table;

            li {
                font-size: 12px;
                color: #5a5a5a;
                min-width: 60px;
                text-align: center;
                margin: 0 5px;
                font-family: "黑体";
                cursor: pointer;
                padding: 5px;
            }

            .select-li {
                color: red;
                text-shadow: red 0px 1px;
            }
        }
    }

    .dropdown-icon-list li {
        float: left;
    }

    #child1 {
        .header1 {
            display: flex;
            min-width: 1200px;
            // justify-content: space-between;
            align-items: center;
            padding-left: 10px;
            height: 64px !important;
            background: #fff !important;
            box-shadow: 0px 0px 10px 0px rgba(236, 33, 45, 0.1);

            .time {
                display: flex;
                flex-direction: row;

                .islook {
                    font-size: 14px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    height: 40px;
                    line-height: 40px;
                    margin-right: 32px;

                    .el-checkbox__input.is-checked .el-checkbox__inner,
                    .el-checkbox__inner {
                        width: 20px;
                        height: 20px;
                    }

                    .el-checkbox__input.is-checked .el-checkbox__inner::after,
                    .el-checkbox__inner::after {
                        left: 8px;
                        top: 4px;
                    }
                }

                .time-title {
                    font-size: 14px;
                    font-family: SimSun;
                    font-weight: 400;
                    color: #333333;
                    height: 40px;
                    line-height: 40px;
                    margin-right: 7px;
                }

                .timebox {
                    display: flex;

                    .begintime {
                        .el-date-editor.el-input {
                            width: 120px !important;
                            height: 40px;
                        }

                        .el-input--prefix .el-input__inner {
                            width: 120px;
                            height: 40px;
                            padding-left: 14px;
                            background: #ffffff;
                            border: 1px solid #d2d2d2;
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: initial;
                                right: 2px;

                                .el-input__icon {
                                    line-height: 36px;
                                }
                            }
                        }
                    }

                    .line {
                        width: 9px;
                        height: 1px;
                        margin: 10px;
                        margin-top: 20px;
                        background-color: #999999;
                    }

                    .endtime {
                        .el-date-editor.el-input {
                            width: 120px !important;
                            height: 40px;
                        }

                        .el-input--prefix .el-input__inner {
                            width: 120px;
                            height: 40px;
                            padding-left: 14px;
                            background: #ffffff;
                            border: 1px solid #d2d2d2;
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: initial;
                                right: 2px;

                                .el-input__icon {
                                    line-height: 36px;
                                }
                            }
                        }
                    }
                }
            }

            .follow {
                margin-left: 70px;
            }

            .record {
                margin-left: 35px;
                margin-right: 30px;
            }
        }

        .body1 {
            margin-top: 10px;
            display: flex;
            flex-wrap: wrap;
            margin-left: -12px;

            .combox {
                width: 254px;
                height: 448px;
                padding: 12px;
                box-sizing: border-box;
                background: #ffffff;
                border: 1px solid #d2d2d2;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                margin-left: 12px;
                margin-bottom: 12px;

                .imgbox {
                    position: relative;

                    img {
                        width: 227px;
                        height: 227px;
                    }

                    .self-support {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 36px;
                        height: 18px;
                        border-radius: 2px;
                        line-height: 18px;
                        text-align: center;
                        background: #EC212D;
                        font-size: 12px;
                        color: #fff;
                    }
                }

                .contentbox {
                    position: relative;

                    .isDirectoryPool {
                        height: 24px;
                        line-height: 24px;
                        padding-left: 10px;
                        background: #fbd2d5;
                        font-size: 14px;
                        color: #EC212D;
                        font-weight: bold;
                    }

                    .ability {
                        margin-top: 12px;
                        .ability-btn {
                            caret-color: rgba(0,0,0,0);
                            cursor: pointer;
                            display: inline-block;
                            width: 110px;
                            height: 32px;
                            line-height: 32px;
                            text-align: center;
                            border: 1px solid #E8E8E8;
                            border-radius: 4px;
                            font-size: 12px;
                            color: #EC212D;
                            .writeText {
                                color: #333;
                            }
                            .iconHover {
                                display: none;
                            }
                        }
                        .ability-btn:hover {
                            background: #EC212D;
                            border-color: #EC212D;
                            color: #fff;
                            .writeText {
                                color: #fff;
                            }
                            .iconEnter {
                                display: none;
                            }
                            .iconHover {
                                display: inline-block;
                            }
                        }
                    }

                    .isshoped {
                        background: #fbd2d5;
                        font-size: 12px;
                        font-weight: bold;
                        color: #ec212d;
                        float: right;
                        width: 64px;
                        height: 22px;
                        line-height: 22px;
                        text-align: center;
                    }

                    .bianma {
                        font-size: 12px;
                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                        font-weight: 400;
                        color: #666666;
                        line-height: 22px;

                        div {
                            display: inline-block;
                            max-width: 150px;
                            overflow: hidden;
                            text-overflow: ellipsis;

                            vertical-align: bottom;
                        }

                        i {
                            cursor: pointer;
                            margin-left: 6px;
                        }
                    }

                    #noShowPrice {
                        position: relative;
                        top: 3px;
                        width: 100%;
                        text-align: left;
                        padding-left: 10px;

                        .shopcar {
                            top: 5px;
                        }
                    }

                    .storeName {
                        // margin-left: 9px;
                        margin: 8px 0px 0;
                        font-size: 14px;
                        color: #000;
                        //   margin-top: 8px;
                        overflow: hidden;
                        /*溢出隐藏*/
                        white-space: nowrap;
                        /*规定文本不进行换行*/
                        text-overflow: ellipsis;

                        /*当对象内文本溢出时显示省略标记（...）*/
                        .deliverData {
                            font-size: 12px;
                            color: #fff;
                            background: #ff8e50;
                            padding: 0 5px;
                            font-family: Microsoft YaHei;
                            line-height: 16px;
                            border-radius: 5px;
                        }
                    }

                    .deliverData {
                        font-size: 12px;
                        color: #fff;
                        background: #ff8e50;
                        padding: 2px 5px;
                        font-family: Microsoft YaHei;
                        line-height: 16px;
                    }

                    .showtime {
                        display: flex;
                        justify-content: space-between;
                        margin-top: 12px;

                        .left {
                            width: 115px;
                            height: 32px;
                            line-height: 32px;
                            text-align: center;
                            font-size: 12px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            font-weight: 400;
                            color: #ec212d;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #e8e8e8;
                            box-sizing: border-box;

                            i {
                                font-size: 16px;
                                vertical-align: middle;
                            }
                        }

                        .right {
                            width: 115px;
                            height: 32px;
                            line-height: 32px;
                            text-align: center;
                            font-size: 12px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            font-weight: 400;
                            color: #333333;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #e8e8e8;
                            display: flex;
                            box-sizing: border-box;
                            justify-content: center;
                            cursor: pointer;

                            .svg-icon {
                                margin: auto 0;
                                margin-right: 7px;
                            }
                        }
                    }

                    .title {
                        height: 37px;
                        margin-left: 0px;
                        margin-bottom: 9px;
                        width: 230px;
                        //   text-overflow: ellipsis;
                        //   white-space: nowrap;
                        font-size: 14px;
                        //   font-family: SimSun;
                        font-weight: 400;
                        color: #000;
                        display: -webkit-box;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-all;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2; //此处为行数，可以改为任意数字
                    }

                    .model {
                        margin-left: 9px;
                        margin-top: 7px;
                        font-size: 14px;
                        font-family: SimSun;
                        font-weight: 400;
                        color: #999999;
                    }

                    .price {
                        // margin-top: 8px;
                        padding: 10px 0;
                        margin-left: 0px;
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #ec212d;

                        .a {
                            display: inline-block;
                            transform: scale(0.83, 0.83);
                        }

                        .b {
                            font-size: 14px;
                        }
                    }

                    .shopcar {
                        font-size: 16px;
                        position: absolute;
                        right: 10px;
                        top: 2px;
                    }
                }
            }
        }
    }
</style>
